
























































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { APICarrier } from '@/models/api/carrier.model'
import { Component, Vue } from 'vue-property-decorator'
import { APIProvider } from '../../models/api/provider.model'

@Component
export default class ShortcodesForm extends Vue {
    loading = true;
    data: { [key: string]: unknown } = {};
    keySelect= 0

    cardTitle = '';

    buttonLoading = false;

    formData: { [key: string]: any } = {
        shortcodeEnabled: true,
        typeId: {
            id: null
        }
    };

    formValid = false;
    formRules = {
        required: [(v: string) => !!v || 'This field is required'],
        shortcode: [
            (v: string) => !!v || 'This field is required',
            (v: string) =>
                (v && v.length <= 20) || 'Field must be less than 20 characters'
        ]
    };

    formModel: {
        carriers: APICarrier[];
        providers: APIProvider[];
        types: object[];
    } = {
        carriers: [],
        providers: [],
        types: [
            {
                text: 'free',
                value: 'free'
            },
            {
                text: 'charge',
                value: 'charge'
            },
            {
                text: 'charge oneshot',
                value: 'charge_oneshot'
            }
        ]
    };

    getCarriers () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getCarriers').then(resp => {
                if (resp.status === 200) {
                    this.formModel.carriers = this.$store.state?.CarriersStore?.carriers?.map(
                        (p: APICarrier) => {
                            return {
                                text: p.carrierName,
                                value: p.carrierId
                            }
                        }
                    )
                    resolve()
                }
            })
        })
    }

    handleOnChangeCarrier (v: number) {
        if (typeof v !== 'number') return
        this.formData.carrierId = v
        if (this.formModel.providers.length) {
            this.formData.providerId = null
        }
        this.formModel.providers = (this.$store.state.ProvidersStore?.providers || []).filter(
            (v: APIProvider & {carrierId: APICarrier}) => {
                return v.carrierId?.carrierId === this.formData.carrierId
            }
        )
            .map((p: APIProvider) => {
                return {
                    text: p.providerName,
                    value: p.providerId
                }
            })
        this.keySelect += 1
    }

    async mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', {
                code: 1000,
                message: 'Error, not action sended in route params :('
            })
            return
        }

        await Promise.all([this.getProviders(), this.getCarriers()])
        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit Shortcode'
            this.getData()
            break
        case 'add':
            this.cardTitle = 'Create Shortcode'
            this.data = {}
            this.loading = false
            break
        }
    }

    async getProviders () {
        await this.$store.dispatch('getProviders')
        this.formModel.providers = (this.$store.state.ProvidersStore?.providers || []).filter(
            (v: APIProvider & {carrierId: APICarrier}) => {
                return v.carrierId?.carrierId === this.formData.carrierId
            }
        )
            .map((p: APIProvider) => {
                return {
                    text: p.providerName,
                    value: p.providerId
                }
            })
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', {
                code: 1000,
                message: 'Error, not id sended in route params :('
            })
            this.loading = false
            return
        }
        this.$store
            .dispatch('getShortcodesById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.ShortcodesStore.shortcodeForm
                    this.formData.carrierId = this.formData.providerId.carrierId.carrierId
                    this.formData.providerId = this.formData.providerId.providerId

                    this.formModel.providers = (this.$store.state.ProvidersStore?.providers || [])
                        .filter((v: APIProvider & {carrierId: APICarrier}) => {
                            return v.carrierId?.carrierId === this.formData.carrierId
                        })
                        .map((p: APIProvider) => {
                            return {
                                text: p.providerName,
                                value: p.providerId
                            }
                        })
                    this.keySelect += this.formModel.providers.findIndex((p: APIProvider) => {
                        return p.providerId === this.formData.providerId
                    })
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        this.buttonLoading = true

        switch (this.$route.params.action) {
        case 'edit':
            this.$store
                .dispatch('editShortcodes', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit(
                            'reportSuccess',
                            'Done Successfully!'
                        )
                        this.$router
                            .push({
                                name: 'Shortcodes'
                            })
                            .then(() => {
                                this.buttonLoading = false
                            })
                    }
                })
            break
        case 'add':
            this.$store
                .dispatch('createShortcodes', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit(
                            'reportSuccess',
                            'Done Successfully!'
                        )
                        this.$router
                            .push({
                                name: 'Shortcodes'
                            })
                            .then(() => {
                                this.buttonLoading = false
                            })
                    }
                })
            break
        }
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date
            .getDate()
            .toString()
            .padStart(2, '0')
        const month = date
            .getMonth()
            .toString()
            .padStart(2, '0')
        const year = date
            .getFullYear()
            .toString()
            .padStart(4, '0')
        const hours = date
            .getHours()
            .toString()
            .padStart(2, '0')
        const minutes = date
            .getMinutes()
            .toString()
            .padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
